import React from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CardMedia from '@material-ui/core/CardMedia';
import CardActionArea from '@material-ui/core/CardActionArea';
import Button from '@material-ui/core/Button';

import { makeStyles } from '@material-ui/core/styles';
import { advertising } from './__data';

const useStyles = makeStyles((theme) => ({
  paper: {
    height: '100%',
    padding: theme.spacing(4),
    boxShadow: 'none'
  },
  section: {
    padding: '5rem 0',
    backgroundColor: 'white'
  },
  media: {
    backgroundColor: 'white'
  },
}));

const ImpactView = () => {
  const classes = useStyles();

  return (
    <>
      <Grid
        className={classes.section}
        component="article"
        container
      >
        <Grid
          item
          md={7}
          sm={12}
          xs={12}
        >
          <Paper
            className={classes.paper}
          >
            <Typography variant="h1">
              Régie publicitaire<br />
              <span style={{color: '#70C359'}}>
                ECO-RESPONSABLE
              </span>
            </Typography>
            <Typography
              component="p"
              variant="body2"
            >
              La publicité standard est remplacée par des reportages de terrain de 30s des projets forestier que vous soutenez. Regarder des éco-pub vous permet de financer gratuitement des arbres réels grâce au partenariat d’entreprises engagées.
            </Typography>
          </Paper>
        </Grid>
        <Grid
          item
          md={5}
          sm={12}
          xs={12}
        >
          <Paper className={classes.paper}>
            <CardActionArea>
              <CardMedia
                alt={advertising.alt}
                className={classes.media}
                component="video"
                controls
                image={advertising.video}
                object-fit
                title={advertising.title}
              />
            </CardActionArea>
          </Paper>
        </Grid>
        <Grid>
          <Paper
            className={classes.paper}
          >
            <Typography
              component="p"
              style={{fontWeight: 700}}
              variant="body2"
            >
              Notre plus grande préoccupation est de pouvoir offrir à toute notre communauté la possibilité de financer des arbres tout en respectant votre expérience de jeu et surtout notre vision basée sur des valeurs éthiques et éco-responsables.
            </Typography>
            <Button
              color="primary"
              disabled
              size="large"
              style={{marginTop: '2.5rem'}}
              variant="contained"
            >
              Accéder à la régie publicitaire
            </Button>
          </Paper>
        </Grid>
      </Grid>
    </>
  );
}

export default ImpactView;
